import styled from 'styled-components';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface ICostAnalysisProps {
  profitAnalysis: ReturnType<NplCalculation['getProfitAnalysis']>;
}

const CostAnalysis = (props: ICostAnalysisProps) => {
  const { profitAnalysis } = props;
  return (
    <s.Div>
      <s.Title>비용분석</s.Title>
      <div>
        <s.Grid>
          <s.InfoCell backgroundColor="#F7F8FC" style={{ gap: '2px' }}>
            <s.CellTitle>A안</s.CellTitle>
            <s.CellContent>자기자본 투자</s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F7F8FC" style={{ gap: '2px' }}>
            <s.CellTitle>B안</s.CellTitle>
            <s.CellContent>레버리지 투자</s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>채권최고액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row1_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>질권(LTV)</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row1_2, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>(예상) 대출원금</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row2_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>질권 대출금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row2_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              (예상)
              <br />
              대출잔액 + 미수이자
            </s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row3_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle>질권 이자율</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row3_2, true, true)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              부실채권 할인금액
              <br />
              (할인율 52%)
            </s.CellTitle>
            <s.CellContent color="#F45551">
              {ReportFormatNumber(profitAnalysis.row4_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>질권 이자비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row4_3)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>부실채권 매입금액</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row5_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>질권 인지세</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row5_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              선비용 (질권 인지세+
              <br />
              거래수수료 1.5%)
            </s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row6_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>질권 취급수수료(0.5%)</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row6_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              선비용 (근저당권
              <br />
              이전수수료 0.5%)
            </s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row7_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              기초자본(자기자본+
              <br />
              거래수수료+이전비용)
            </s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row7_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">A안 비용 소계</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row8_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">B안 비용 소계</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row8_2)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>
              경매비용
              <br />
              (예상낙찰가격의 0.5%)
            </s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row9)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell>
            <s.CellTitle>경매비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row9)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">A안 총 투자비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row10_1)}
            </s.CellContent>
          </s.InfoCell>
          <s.InfoCell backgroundColor="#F2F7FF">
            <s.CellTitle color="#008AFF">B안 총 투자비용</s.CellTitle>
            <s.CellContent>
              {ReportFormatNumber(profitAnalysis.row10_2)}
            </s.CellContent>
          </s.InfoCell>
        </s.Grid>
        <s.BlueSmallText>
          *부실채권 할인금액은 할인율에 따라 변동될 수 있음
        </s.BlueSmallText>
        <s.BlueSmallText>
          *비용내역은 요율에 따라 변경될 수 있음
        </s.BlueSmallText>
      </div>
    </s.Div>
  );
};

export default CostAnalysis;
